import { createContext } from 'react'
import { IAddAttachmentsRPContext } from '../interfaces/IAddAttachmentsRPContext'

export const AddAttachmentsRPContext = createContext<IAddAttachmentsRPContext>({
  ecmCategoryModel: [],
  ecmCategoryDropdownLoading: true,
})
